var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-SWITCH"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SWITCH",
    clipPath: "url(#clip-SWITCH)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_77",
    "data-name": "Rectangle 77",
    transform: "translate(13.521 174.791)",
    fill: "#090000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,77.822l483.8-.791L435.328,2.038,30.989,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 433.5337219238281 3.09882640838623 L 479.8829956054688 75.51617431640625 L 3.827553510665894 76.22991180419922 L 33.21833419799805 1.119102478027344 L 433.5337219238281 3.09882640838623 M 435.3281555175781 2.038061618804932 L 30.98925018310547 -1.999545202124864e-05 L -0.0002933976356871426 77.82175445556641 L 483.8039245605469 77.03072357177734 L 435.3281555175781 2.038061618804932 Z",
    stroke: "none",
    fill: "#090000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_72",
    "data-name": "Rectangle 72",
    transform: "translate(7 252)",
    fill: "#7b7474",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 494,
    height: 71,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 493,
    height: 70,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_73",
    "data-name": "Rectangle 73",
    transform: "translate(29 258)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 399,
    height: 52,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 396,
    height: 49,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_166",
    "data-name": "Group 166"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_159",
    "data-name": "Group 159",
    transform: "translate(32.643 263)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_158",
    "data-name": "Group 158"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160",
    "data-name": "Group 160"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_299",
    "data-name": "Path 299",
    d: "M153.454,172.973H170.9a1.339,1.339,0,0,0,1.454-1.182v-9.456a1.339,1.339,0,0,0-1.454-1.182h-2.423v-1.97A1.339,1.339,0,0,0,167.02,158h-9.69a1.339,1.339,0,0,0-1.454,1.182v1.97h-2.423A1.339,1.339,0,0,0,152,162.334v9.456A1.339,1.339,0,0,0,153.454,172.973Zm1.454-9.456h2.423a1.339,1.339,0,0,0,1.454-1.182v-1.97h6.783v1.97a1.339,1.339,0,0,0,1.454,1.182h2.423v7.092H154.907Z",
    transform: "translate(-152 -158)",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    d: "M153.454,172.973H170.9a1.339,1.339,0,0,0,1.454-1.182v-9.456a1.339,1.339,0,0,0-1.454-1.182h-2.423v-1.97A1.339,1.339,0,0,0,167.02,158h-9.69a1.339,1.339,0,0,0-1.454,1.182v1.97h-2.423A1.339,1.339,0,0,0,152,162.334v9.456A1.339,1.339,0,0,0,153.454,172.973Zm1.454-9.456h2.423a1.339,1.339,0,0,0,1.454-1.182v-1.97h6.783v1.97a1.339,1.339,0,0,0,1.454,1.182h2.423v7.092H154.907Z",
    transform: "translate(-131 -158)",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    "data-name": "Path 301",
    d: "M153.454,172.973H170.9a1.339,1.339,0,0,0,1.454-1.182v-9.456a1.339,1.339,0,0,0-1.454-1.182h-2.423v-1.97A1.339,1.339,0,0,0,167.02,158h-9.69a1.339,1.339,0,0,0-1.454,1.182v1.97h-2.423A1.339,1.339,0,0,0,152,162.334v9.456A1.339,1.339,0,0,0,153.454,172.973Zm1.454-9.456h2.423a1.339,1.339,0,0,0,1.454-1.182v-1.97h6.783v1.97a1.339,1.339,0,0,0,1.454,1.182h2.423v7.092H154.907Z",
    transform: "translate(-110 -158)",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_302",
    "data-name": "Path 302",
    d: "M153.454,172.973H170.9a1.339,1.339,0,0,0,1.454-1.182v-9.456a1.339,1.339,0,0,0-1.454-1.182h-2.423v-1.97A1.339,1.339,0,0,0,167.02,158h-9.69a1.339,1.339,0,0,0-1.454,1.182v1.97h-2.423A1.339,1.339,0,0,0,152,162.334v9.456A1.339,1.339,0,0,0,153.454,172.973Zm1.454-9.456h2.423a1.339,1.339,0,0,0,1.454-1.182v-1.97h6.783v1.97a1.339,1.339,0,0,0,1.454,1.182h2.423v7.092H154.907Z",
    transform: "translate(-89 -158)",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    d: "M153.454,172.973H170.9a1.339,1.339,0,0,0,1.454-1.182v-9.456a1.339,1.339,0,0,0-1.454-1.182h-2.423v-1.97A1.339,1.339,0,0,0,167.02,158h-9.69a1.339,1.339,0,0,0-1.454,1.182v1.97h-2.423A1.339,1.339,0,0,0,152,162.334v9.456A1.339,1.339,0,0,0,153.454,172.973Zm1.454-9.456h2.423a1.339,1.339,0,0,0,1.454-1.182v-1.97h6.783v1.97a1.339,1.339,0,0,0,1.454,1.182h2.423v7.092H154.907Z",
    transform: "translate(-68 -158)",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    d: "M153.454,172.973H170.9a1.339,1.339,0,0,0,1.454-1.182v-9.456a1.339,1.339,0,0,0-1.454-1.182h-2.423v-1.97A1.339,1.339,0,0,0,167.02,158h-9.69a1.339,1.339,0,0,0-1.454,1.182v1.97h-2.423A1.339,1.339,0,0,0,152,162.334v9.456A1.339,1.339,0,0,0,153.454,172.973Zm1.454-9.456h2.423a1.339,1.339,0,0,0,1.454-1.182v-1.97h6.783v1.97a1.339,1.339,0,0,0,1.454,1.182h2.423v7.092H154.907Z",
    transform: "translate(-47 -158)",
    stroke: "#000",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_161",
    "data-name": "Group 161",
    transform: "translate(197.997 271)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_158-2",
    "data-name": "Group 158"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160-2",
    "data-name": "Group 160",
    transform: "translate(-71 -92)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_299-2",
    "data-name": "Path 299",
    d: "M153.454,172.973H170.9a1.339,1.339,0,0,0,1.454-1.182v-9.456a1.339,1.339,0,0,0-1.454-1.182h-2.423v-1.97A1.339,1.339,0,0,0,167.02,158h-9.69a1.339,1.339,0,0,0-1.454,1.182v1.97h-2.423A1.339,1.339,0,0,0,152,162.334v9.456A1.339,1.339,0,0,0,153.454,172.973Zm1.454-9.456h2.423a1.339,1.339,0,0,0,1.454-1.182v-1.97h6.783v1.97a1.339,1.339,0,0,0,1.454,1.182h2.423v7.092H154.907Z",
    transform: "translate(-114.354 -74)",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_300-2",
    "data-name": "Path 300",
    d: "M153.454,172.973H170.9a1.339,1.339,0,0,0,1.454-1.182v-9.456a1.339,1.339,0,0,0-1.454-1.182h-2.423v-1.97A1.339,1.339,0,0,0,167.02,158h-9.69a1.339,1.339,0,0,0-1.454,1.182v1.97h-2.423A1.339,1.339,0,0,0,152,162.334v9.456A1.339,1.339,0,0,0,153.454,172.973Zm1.454-9.456h2.423a1.339,1.339,0,0,0,1.454-1.182v-1.97h6.783v1.97a1.339,1.339,0,0,0,1.454,1.182h2.423v7.092H154.907Z",
    transform: "translate(-93.354 -74)",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_301-2",
    "data-name": "Path 301",
    d: "M153.454,172.973H170.9a1.339,1.339,0,0,0,1.454-1.182v-9.456a1.339,1.339,0,0,0-1.454-1.182h-2.423v-1.97A1.339,1.339,0,0,0,167.02,158h-9.69a1.339,1.339,0,0,0-1.454,1.182v1.97h-2.423A1.339,1.339,0,0,0,152,162.334v9.456A1.339,1.339,0,0,0,153.454,172.973Zm1.454-9.456h2.423a1.339,1.339,0,0,0,1.454-1.182v-1.97h6.783v1.97a1.339,1.339,0,0,0,1.454,1.182h2.423v7.092H154.907Z",
    transform: "translate(-72.354 -74)",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_302-2",
    "data-name": "Path 302",
    d: "M153.454,172.973H170.9a1.339,1.339,0,0,0,1.454-1.182v-9.456a1.339,1.339,0,0,0-1.454-1.182h-2.423v-1.97A1.339,1.339,0,0,0,167.02,158h-9.69a1.339,1.339,0,0,0-1.454,1.182v1.97h-2.423A1.339,1.339,0,0,0,152,162.334v9.456A1.339,1.339,0,0,0,153.454,172.973Zm1.454-9.456h2.423a1.339,1.339,0,0,0,1.454-1.182v-1.97h6.783v1.97a1.339,1.339,0,0,0,1.454,1.182h2.423v7.092H154.907Z",
    transform: "translate(-51.354 -74)",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_303-2",
    "data-name": "Path 303",
    d: "M153.454,172.973H170.9a1.339,1.339,0,0,0,1.454-1.182v-9.456a1.339,1.339,0,0,0-1.454-1.182h-2.423v-1.97A1.339,1.339,0,0,0,167.02,158h-9.69a1.339,1.339,0,0,0-1.454,1.182v1.97h-2.423A1.339,1.339,0,0,0,152,162.334v9.456A1.339,1.339,0,0,0,153.454,172.973Zm1.454-9.456h2.423a1.339,1.339,0,0,0,1.454-1.182v-1.97h6.783v1.97a1.339,1.339,0,0,0,1.454,1.182h2.423v7.092H154.907Z",
    transform: "translate(-30.354 -74)",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_304-2",
    "data-name": "Path 304",
    d: "M153.454,172.973H170.9a1.339,1.339,0,0,0,1.454-1.182v-9.456a1.339,1.339,0,0,0-1.454-1.182h-2.423v-1.97A1.339,1.339,0,0,0,167.02,158h-9.69a1.339,1.339,0,0,0-1.454,1.182v1.97h-2.423A1.339,1.339,0,0,0,152,162.334v9.456A1.339,1.339,0,0,0,153.454,172.973Zm1.454-9.456h2.423a1.339,1.339,0,0,0,1.454-1.182v-1.97h6.783v1.97a1.339,1.339,0,0,0,1.454,1.182h2.423v7.092H154.907Z",
    transform: "translate(-9.354 -74)",
    stroke: "#000",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_162",
    "data-name": "Group 162",
    transform: "translate(329.997 271)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_158-3",
    "data-name": "Group 158"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160-3",
    "data-name": "Group 160",
    transform: "translate(-71 -92)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_299-3",
    "data-name": "Path 299",
    d: "M153.454,172.973H170.9a1.339,1.339,0,0,0,1.454-1.182v-9.456a1.339,1.339,0,0,0-1.454-1.182h-2.423v-1.97A1.339,1.339,0,0,0,167.02,158h-9.69a1.339,1.339,0,0,0-1.454,1.182v1.97h-2.423A1.339,1.339,0,0,0,152,162.334v9.456A1.339,1.339,0,0,0,153.454,172.973Zm1.454-9.456h2.423a1.339,1.339,0,0,0,1.454-1.182v-1.97h6.783v1.97a1.339,1.339,0,0,0,1.454,1.182h2.423v7.092H154.907Z",
    transform: "translate(-114.354 -74)",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_300-3",
    "data-name": "Path 300",
    d: "M153.454,172.973H170.9a1.339,1.339,0,0,0,1.454-1.182v-9.456a1.339,1.339,0,0,0-1.454-1.182h-2.423v-1.97A1.339,1.339,0,0,0,167.02,158h-9.69a1.339,1.339,0,0,0-1.454,1.182v1.97h-2.423A1.339,1.339,0,0,0,152,162.334v9.456A1.339,1.339,0,0,0,153.454,172.973Zm1.454-9.456h2.423a1.339,1.339,0,0,0,1.454-1.182v-1.97h6.783v1.97a1.339,1.339,0,0,0,1.454,1.182h2.423v7.092H154.907Z",
    transform: "translate(-93.354 -74)",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_301-3",
    "data-name": "Path 301",
    d: "M153.454,172.973H170.9a1.339,1.339,0,0,0,1.454-1.182v-9.456a1.339,1.339,0,0,0-1.454-1.182h-2.423v-1.97A1.339,1.339,0,0,0,167.02,158h-9.69a1.339,1.339,0,0,0-1.454,1.182v1.97h-2.423A1.339,1.339,0,0,0,152,162.334v9.456A1.339,1.339,0,0,0,153.454,172.973Zm1.454-9.456h2.423a1.339,1.339,0,0,0,1.454-1.182v-1.97h6.783v1.97a1.339,1.339,0,0,0,1.454,1.182h2.423v7.092H154.907Z",
    transform: "translate(-72.354 -74)",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_302-3",
    "data-name": "Path 302",
    d: "M153.454,172.973H170.9a1.339,1.339,0,0,0,1.454-1.182v-9.456a1.339,1.339,0,0,0-1.454-1.182h-2.423v-1.97A1.339,1.339,0,0,0,167.02,158h-9.69a1.339,1.339,0,0,0-1.454,1.182v1.97h-2.423A1.339,1.339,0,0,0,152,162.334v9.456A1.339,1.339,0,0,0,153.454,172.973Zm1.454-9.456h2.423a1.339,1.339,0,0,0,1.454-1.182v-1.97h6.783v1.97a1.339,1.339,0,0,0,1.454,1.182h2.423v7.092H154.907Z",
    transform: "translate(-51.354 -74)",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_303-3",
    "data-name": "Path 303",
    d: "M153.454,172.973H170.9a1.339,1.339,0,0,0,1.454-1.182v-9.456a1.339,1.339,0,0,0-1.454-1.182h-2.423v-1.97A1.339,1.339,0,0,0,167.02,158h-9.69a1.339,1.339,0,0,0-1.454,1.182v1.97h-2.423A1.339,1.339,0,0,0,152,162.334v9.456A1.339,1.339,0,0,0,153.454,172.973Zm1.454-9.456h2.423a1.339,1.339,0,0,0,1.454-1.182v-1.97h6.783v1.97a1.339,1.339,0,0,0,1.454,1.182h2.423v7.092H154.907Z",
    transform: "translate(-30.354 -74)",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_304-3",
    "data-name": "Path 304",
    d: "M153.454,172.973H170.9a1.339,1.339,0,0,0,1.454-1.182v-9.456a1.339,1.339,0,0,0-1.454-1.182h-2.423v-1.97A1.339,1.339,0,0,0,167.02,158h-9.69a1.339,1.339,0,0,0-1.454,1.182v1.97h-2.423A1.339,1.339,0,0,0,152,162.334v9.456A1.339,1.339,0,0,0,153.454,172.973Zm1.454-9.456h2.423a1.339,1.339,0,0,0,1.454-1.182v-1.97h6.783v1.97a1.339,1.339,0,0,0,1.454,1.182h2.423v7.092H154.907Z",
    transform: "translate(-9.354 -74)",
    stroke: "#000",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_163",
    "data-name": "Group 163",
    transform: "translate(32.643 288)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_158-4",
    "data-name": "Group 158"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160-4",
    "data-name": "Group 160"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_299-4",
    "data-name": "Path 299",
    d: "M153.454,158H170.9a1.339,1.339,0,0,1,1.454,1.182v9.456a1.339,1.339,0,0,1-1.454,1.182h-2.423v1.97a1.339,1.339,0,0,1-1.454,1.182h-9.69a1.339,1.339,0,0,1-1.454-1.182v-1.97h-2.423A1.339,1.339,0,0,1,152,168.638v-9.456A1.339,1.339,0,0,1,153.454,158Zm1.454,9.456h2.423a1.339,1.339,0,0,1,1.454,1.182v1.97h6.783v-1.97a1.339,1.339,0,0,1,1.454-1.182h2.423v-7.092H154.907Z",
    transform: "translate(-152 -158)",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_300-4",
    "data-name": "Path 300",
    d: "M153.454,158H170.9a1.339,1.339,0,0,1,1.454,1.182v9.456a1.339,1.339,0,0,1-1.454,1.182h-2.423v1.97a1.339,1.339,0,0,1-1.454,1.182h-9.69a1.339,1.339,0,0,1-1.454-1.182v-1.97h-2.423A1.339,1.339,0,0,1,152,168.638v-9.456A1.339,1.339,0,0,1,153.454,158Zm1.454,9.456h2.423a1.339,1.339,0,0,1,1.454,1.182v1.97h6.783v-1.97a1.339,1.339,0,0,1,1.454-1.182h2.423v-7.092H154.907Z",
    transform: "translate(-131 -158)",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_301-4",
    "data-name": "Path 301",
    d: "M153.454,158H170.9a1.339,1.339,0,0,1,1.454,1.182v9.456a1.339,1.339,0,0,1-1.454,1.182h-2.423v1.97a1.339,1.339,0,0,1-1.454,1.182h-9.69a1.339,1.339,0,0,1-1.454-1.182v-1.97h-2.423A1.339,1.339,0,0,1,152,168.638v-9.456A1.339,1.339,0,0,1,153.454,158Zm1.454,9.456h2.423a1.339,1.339,0,0,1,1.454,1.182v1.97h6.783v-1.97a1.339,1.339,0,0,1,1.454-1.182h2.423v-7.092H154.907Z",
    transform: "translate(-110 -158)",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_302-4",
    "data-name": "Path 302",
    d: "M153.454,158H170.9a1.339,1.339,0,0,1,1.454,1.182v9.456a1.339,1.339,0,0,1-1.454,1.182h-2.423v1.97a1.339,1.339,0,0,1-1.454,1.182h-9.69a1.339,1.339,0,0,1-1.454-1.182v-1.97h-2.423A1.339,1.339,0,0,1,152,168.638v-9.456A1.339,1.339,0,0,1,153.454,158Zm1.454,9.456h2.423a1.339,1.339,0,0,1,1.454,1.182v1.97h6.783v-1.97a1.339,1.339,0,0,1,1.454-1.182h2.423v-7.092H154.907Z",
    transform: "translate(-89 -158)",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_303-4",
    "data-name": "Path 303",
    d: "M153.454,158H170.9a1.339,1.339,0,0,1,1.454,1.182v9.456a1.339,1.339,0,0,1-1.454,1.182h-2.423v1.97a1.339,1.339,0,0,1-1.454,1.182h-9.69a1.339,1.339,0,0,1-1.454-1.182v-1.97h-2.423A1.339,1.339,0,0,1,152,168.638v-9.456A1.339,1.339,0,0,1,153.454,158Zm1.454,9.456h2.423a1.339,1.339,0,0,1,1.454,1.182v1.97h6.783v-1.97a1.339,1.339,0,0,1,1.454-1.182h2.423v-7.092H154.907Z",
    transform: "translate(-68 -158)",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_304-4",
    "data-name": "Path 304",
    d: "M153.454,158H170.9a1.339,1.339,0,0,1,1.454,1.182v9.456a1.339,1.339,0,0,1-1.454,1.182h-2.423v1.97a1.339,1.339,0,0,1-1.454,1.182h-9.69a1.339,1.339,0,0,1-1.454-1.182v-1.97h-2.423A1.339,1.339,0,0,1,152,168.638v-9.456A1.339,1.339,0,0,1,153.454,158Zm1.454,9.456h2.423a1.339,1.339,0,0,1,1.454,1.182v1.97h6.783v-1.97a1.339,1.339,0,0,1,1.454-1.182h2.423v-7.092H154.907Z",
    transform: "translate(-47 -158)",
    stroke: "#000",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_164",
    "data-name": "Group 164",
    transform: "translate(164.643 288)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_158-5",
    "data-name": "Group 158"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160-5",
    "data-name": "Group 160"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_299-5",
    "data-name": "Path 299",
    d: "M153.454,158H170.9a1.339,1.339,0,0,1,1.454,1.182v9.456a1.339,1.339,0,0,1-1.454,1.182h-2.423v1.97a1.339,1.339,0,0,1-1.454,1.182h-9.69a1.339,1.339,0,0,1-1.454-1.182v-1.97h-2.423A1.339,1.339,0,0,1,152,168.638v-9.456A1.339,1.339,0,0,1,153.454,158Zm1.454,9.456h2.423a1.339,1.339,0,0,1,1.454,1.182v1.97h6.783v-1.97a1.339,1.339,0,0,1,1.454-1.182h2.423v-7.092H154.907Z",
    transform: "translate(-152 -158)",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_300-5",
    "data-name": "Path 300",
    d: "M153.454,158H170.9a1.339,1.339,0,0,1,1.454,1.182v9.456a1.339,1.339,0,0,1-1.454,1.182h-2.423v1.97a1.339,1.339,0,0,1-1.454,1.182h-9.69a1.339,1.339,0,0,1-1.454-1.182v-1.97h-2.423A1.339,1.339,0,0,1,152,168.638v-9.456A1.339,1.339,0,0,1,153.454,158Zm1.454,9.456h2.423a1.339,1.339,0,0,1,1.454,1.182v1.97h6.783v-1.97a1.339,1.339,0,0,1,1.454-1.182h2.423v-7.092H154.907Z",
    transform: "translate(-131 -158)",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_301-5",
    "data-name": "Path 301",
    d: "M153.454,158H170.9a1.339,1.339,0,0,1,1.454,1.182v9.456a1.339,1.339,0,0,1-1.454,1.182h-2.423v1.97a1.339,1.339,0,0,1-1.454,1.182h-9.69a1.339,1.339,0,0,1-1.454-1.182v-1.97h-2.423A1.339,1.339,0,0,1,152,168.638v-9.456A1.339,1.339,0,0,1,153.454,158Zm1.454,9.456h2.423a1.339,1.339,0,0,1,1.454,1.182v1.97h6.783v-1.97a1.339,1.339,0,0,1,1.454-1.182h2.423v-7.092H154.907Z",
    transform: "translate(-110 -158)",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_302-5",
    "data-name": "Path 302",
    d: "M153.454,158H170.9a1.339,1.339,0,0,1,1.454,1.182v9.456a1.339,1.339,0,0,1-1.454,1.182h-2.423v1.97a1.339,1.339,0,0,1-1.454,1.182h-9.69a1.339,1.339,0,0,1-1.454-1.182v-1.97h-2.423A1.339,1.339,0,0,1,152,168.638v-9.456A1.339,1.339,0,0,1,153.454,158Zm1.454,9.456h2.423a1.339,1.339,0,0,1,1.454,1.182v1.97h6.783v-1.97a1.339,1.339,0,0,1,1.454-1.182h2.423v-7.092H154.907Z",
    transform: "translate(-89 -158)",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_303-5",
    "data-name": "Path 303",
    d: "M153.454,158H170.9a1.339,1.339,0,0,1,1.454,1.182v9.456a1.339,1.339,0,0,1-1.454,1.182h-2.423v1.97a1.339,1.339,0,0,1-1.454,1.182h-9.69a1.339,1.339,0,0,1-1.454-1.182v-1.97h-2.423A1.339,1.339,0,0,1,152,168.638v-9.456A1.339,1.339,0,0,1,153.454,158Zm1.454,9.456h2.423a1.339,1.339,0,0,1,1.454,1.182v1.97h6.783v-1.97a1.339,1.339,0,0,1,1.454-1.182h2.423v-7.092H154.907Z",
    transform: "translate(-68 -158)",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_304-5",
    "data-name": "Path 304",
    d: "M153.454,158H170.9a1.339,1.339,0,0,1,1.454,1.182v9.456a1.339,1.339,0,0,1-1.454,1.182h-2.423v1.97a1.339,1.339,0,0,1-1.454,1.182h-9.69a1.339,1.339,0,0,1-1.454-1.182v-1.97h-2.423A1.339,1.339,0,0,1,152,168.638v-9.456A1.339,1.339,0,0,1,153.454,158Zm1.454,9.456h2.423a1.339,1.339,0,0,1,1.454,1.182v1.97h6.783v-1.97a1.339,1.339,0,0,1,1.454-1.182h2.423v-7.092H154.907Z",
    transform: "translate(-47 -158)",
    stroke: "#000",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_165",
    "data-name": "Group 165",
    transform: "translate(296.643 288)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_158-6",
    "data-name": "Group 158"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160-6",
    "data-name": "Group 160"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_299-6",
    "data-name": "Path 299",
    d: "M153.454,158H170.9a1.339,1.339,0,0,1,1.454,1.182v9.456a1.339,1.339,0,0,1-1.454,1.182h-2.423v1.97a1.339,1.339,0,0,1-1.454,1.182h-9.69a1.339,1.339,0,0,1-1.454-1.182v-1.97h-2.423A1.339,1.339,0,0,1,152,168.638v-9.456A1.339,1.339,0,0,1,153.454,158Zm1.454,9.456h2.423a1.339,1.339,0,0,1,1.454,1.182v1.97h6.783v-1.97a1.339,1.339,0,0,1,1.454-1.182h2.423v-7.092H154.907Z",
    transform: "translate(-152 -158)",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_300-6",
    "data-name": "Path 300",
    d: "M153.454,158H170.9a1.339,1.339,0,0,1,1.454,1.182v9.456a1.339,1.339,0,0,1-1.454,1.182h-2.423v1.97a1.339,1.339,0,0,1-1.454,1.182h-9.69a1.339,1.339,0,0,1-1.454-1.182v-1.97h-2.423A1.339,1.339,0,0,1,152,168.638v-9.456A1.339,1.339,0,0,1,153.454,158Zm1.454,9.456h2.423a1.339,1.339,0,0,1,1.454,1.182v1.97h6.783v-1.97a1.339,1.339,0,0,1,1.454-1.182h2.423v-7.092H154.907Z",
    transform: "translate(-131 -158)",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_301-6",
    "data-name": "Path 301",
    d: "M153.454,158H170.9a1.339,1.339,0,0,1,1.454,1.182v9.456a1.339,1.339,0,0,1-1.454,1.182h-2.423v1.97a1.339,1.339,0,0,1-1.454,1.182h-9.69a1.339,1.339,0,0,1-1.454-1.182v-1.97h-2.423A1.339,1.339,0,0,1,152,168.638v-9.456A1.339,1.339,0,0,1,153.454,158Zm1.454,9.456h2.423a1.339,1.339,0,0,1,1.454,1.182v1.97h6.783v-1.97a1.339,1.339,0,0,1,1.454-1.182h2.423v-7.092H154.907Z",
    transform: "translate(-110 -158)",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_302-6",
    "data-name": "Path 302",
    d: "M153.454,158H170.9a1.339,1.339,0,0,1,1.454,1.182v9.456a1.339,1.339,0,0,1-1.454,1.182h-2.423v1.97a1.339,1.339,0,0,1-1.454,1.182h-9.69a1.339,1.339,0,0,1-1.454-1.182v-1.97h-2.423A1.339,1.339,0,0,1,152,168.638v-9.456A1.339,1.339,0,0,1,153.454,158Zm1.454,9.456h2.423a1.339,1.339,0,0,1,1.454,1.182v1.97h6.783v-1.97a1.339,1.339,0,0,1,1.454-1.182h2.423v-7.092H154.907Z",
    transform: "translate(-89 -158)",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_303-6",
    "data-name": "Path 303",
    d: "M153.454,158H170.9a1.339,1.339,0,0,1,1.454,1.182v9.456a1.339,1.339,0,0,1-1.454,1.182h-2.423v1.97a1.339,1.339,0,0,1-1.454,1.182h-9.69a1.339,1.339,0,0,1-1.454-1.182v-1.97h-2.423A1.339,1.339,0,0,1,152,168.638v-9.456A1.339,1.339,0,0,1,153.454,158Zm1.454,9.456h2.423a1.339,1.339,0,0,1,1.454,1.182v1.97h6.783v-1.97a1.339,1.339,0,0,1,1.454-1.182h2.423v-7.092H154.907Z",
    transform: "translate(-68 -158)",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_304-6",
    "data-name": "Path 304",
    d: "M153.454,158H170.9a1.339,1.339,0,0,1,1.454,1.182v9.456a1.339,1.339,0,0,1-1.454,1.182h-2.423v1.97a1.339,1.339,0,0,1-1.454,1.182h-9.69a1.339,1.339,0,0,1-1.454-1.182v-1.97h-2.423A1.339,1.339,0,0,1,152,168.638v-9.456A1.339,1.339,0,0,1,153.454,158Zm1.454,9.456h2.423a1.339,1.339,0,0,1,1.454,1.182v1.97h6.783v-1.97a1.339,1.339,0,0,1,1.454-1.182h2.423v-7.092H154.907Z",
    transform: "translate(-47 -158)",
    stroke: "#000",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("line", {
    id: "Line_12",
    "data-name": "Line 12",
    y2: 51,
    transform: "translate(161.5 258.5)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_13",
    "data-name": "Line 13",
    y2: 51,
    transform: "translate(293.5 258.5)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_74",
    "data-name": "Rectangle 74",
    transform: "translate(435 295)",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 18,
    height: 14,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_75",
    "data-name": "Rectangle 75",
    transform: "translate(456 295)",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 18,
    height: 14,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_76",
    "data-name": "Rectangle 76",
    transform: "translate(477 295)",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 18,
    height: 14,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_170",
    "data-name": "Group 170"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_167",
    "data-name": "Group 167"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_78",
    "data-name": "Ellipse 78",
    transform: "translate(36 312)",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_79",
    "data-name": "Ellipse 79",
    transform: "translate(46 312)",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_80",
    "data-name": "Ellipse 80",
    transform: "translate(58 312)",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_81",
    "data-name": "Ellipse 81",
    transform: "translate(67 312)",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 1.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_169",
    "data-name": "Group 169",
    transform: "translate(42)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_78-2",
    "data-name": "Ellipse 78",
    transform: "translate(36 312)",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_79-2",
    "data-name": "Ellipse 79",
    transform: "translate(46 312)",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_80-2",
    "data-name": "Ellipse 80",
    transform: "translate(58 312)",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_81-2",
    "data-name": "Ellipse 81",
    transform: "translate(67 312)",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 1.5,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_171",
    "data-name": "Group 171",
    transform: "translate(84)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_167-2",
    "data-name": "Group 167"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_78-3",
    "data-name": "Ellipse 78",
    transform: "translate(36 312)",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_79-3",
    "data-name": "Ellipse 79",
    transform: "translate(46 312)",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_80-3",
    "data-name": "Ellipse 80",
    transform: "translate(58 312)",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_81-3",
    "data-name": "Ellipse 81",
    transform: "translate(67 312)",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 1.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_169-2",
    "data-name": "Group 169",
    transform: "translate(51)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_78-4",
    "data-name": "Ellipse 78",
    transform: "translate(36 312)",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_79-4",
    "data-name": "Ellipse 79",
    transform: "translate(46 312)",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_80-4",
    "data-name": "Ellipse 80",
    transform: "translate(58 312)",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_81-4",
    "data-name": "Ellipse 81",
    transform: "translate(67 312)",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 1.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_172",
    "data-name": "Group 172",
    transform: "translate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_78-5",
    "data-name": "Ellipse 78",
    transform: "translate(36 312)",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_79-5",
    "data-name": "Ellipse 79",
    transform: "translate(46 312)",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_80-5",
    "data-name": "Ellipse 80",
    transform: "translate(58 312)",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_81-5",
    "data-name": "Ellipse 81",
    transform: "translate(67 312)",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 1.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_173",
    "data-name": "Group 173",
    transform: "translate(131)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_78-6",
    "data-name": "Ellipse 78",
    transform: "translate(36 312)",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_79-6",
    "data-name": "Ellipse 79",
    transform: "translate(46 312)",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_80-6",
    "data-name": "Ellipse 80",
    transform: "translate(58 312)",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_81-6",
    "data-name": "Ellipse 81",
    transform: "translate(67 312)",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 1.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_174",
    "data-name": "Group 174",
    transform: "translate(181)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_78-7",
    "data-name": "Ellipse 78",
    transform: "translate(36 312)",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_79-7",
    "data-name": "Ellipse 79",
    transform: "translate(46 312)",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_80-7",
    "data-name": "Ellipse 80",
    transform: "translate(58 312)",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_81-7",
    "data-name": "Ellipse 81",
    transform: "translate(67 312)",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 1.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_175",
    "data-name": "Group 175",
    transform: "translate(222)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_78-8",
    "data-name": "Ellipse 78",
    transform: "translate(36 312)",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_79-8",
    "data-name": "Ellipse 79",
    transform: "translate(46 312)",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_80-8",
    "data-name": "Ellipse 80",
    transform: "translate(58 312)",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_81-8",
    "data-name": "Ellipse 81",
    transform: "translate(67 312)",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 1.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_176",
    "data-name": "Group 176",
    transform: "translate(265)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_78-9",
    "data-name": "Ellipse 78",
    transform: "translate(36 312)",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_79-9",
    "data-name": "Ellipse 79",
    transform: "translate(46 312)",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_80-9",
    "data-name": "Ellipse 80",
    transform: "translate(58 312)",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_81-9",
    "data-name": "Ellipse 81",
    transform: "translate(67 312)",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 1.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_177",
    "data-name": "Group 177",
    transform: "translate(323)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_78-10",
    "data-name": "Ellipse 78",
    transform: "translate(36 312)",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_80-10",
    "data-name": "Ellipse 80",
    transform: "translate(57 312)",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_81-10",
    "data-name": "Ellipse 81",
    transform: "translate(77 312)",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 1.5,
    fill: "none"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitch);
export default __webpack_public_path__ + "static/media/SWITCH.611483c44d921dcad9ed1d6f798e4d62.svg";
export { ForwardRef as ReactComponent };